import { Dimensions, StyleSheet } from 'react-native'
import { DS } from '../../../design-system'

// Long tournament / community game names would otherwise stretch the drawer
// to fit a single line. Cap the name at 2/3 of the screen width and wrap.
const NAME_MAX_WIDTH = Dimensions.get('window').width * 0.67

export const TableName = ({ name, type, subtitle }: { name: string; type: string; subtitle?: string }) => {
  return (
    <DS.Frame style={styles.container}>
      <DS.Text variant="Caption/Bold">{type.toUpperCase()}</DS.Text>
      <DS.Text variant="Heading 2/Medium" style={styles.name}>
        {name}
      </DS.Text>
      {subtitle && <DS.Text variant={'Body Medium/Regular'}>{subtitle}</DS.Text>}
    </DS.Frame>
  )
}

const styles = StyleSheet.create({
  container: {
    paddingVertical: DS.spacing[14.5],
    flexDirection: 'column',
    gap: DS.spacing[4],
    alignItems: 'flex-end'
  },
  name: {
    maxWidth: NAME_MAX_WIDTH,
    textAlign: 'right'
  }
})
